import React from "react";
import "../css/home.scss";

const CENTURION_EVENT_DATE = {
  year: 2026,
  monthIndex: 8,
  day: 19
};

const HIDDEN_CENTURION_DATE_LABELS = [
  "Abstract submission",
  "Илтгэлийн хураангуй хүлээн авах"
];

const CENTURION_EARLY_BIRD_LABEL = "Early bird";

const getCenturionDateLabelParts = (label) => {
  const separatorIndex = label.lastIndexOf(":");

  if (separatorIndex === -1) {
    return {
      label,
      tag: ""
    };
  }

  return {
    label: label.slice(0, separatorIndex).trim(),
    tag: label.slice(separatorIndex + 1).trim()
  };
};

const isCenturionEarlyBirdDate = (item) => {
  return getCenturionDateLabelParts(item.label).tag.toLowerCase() === CENTURION_EARLY_BIRD_LABEL.toLowerCase();
};

const getUlaanbaatarTodayParts = () => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Ulaanbaatar",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(new Date()).reduce((acc, part) => {
    if (part.type !== "literal") {
      acc[part.type] = Number(part.value);
    }
    return acc;
  }, {});

  return {
    year: parts.year,
    monthIndex: parts.month - 1,
    day: parts.day
  };
};

const getDaysUntilCenturionEvent = () => {
  const today = getUlaanbaatarTodayParts();
  const todayUtc = Date.UTC(today.year, today.monthIndex, today.day);
  const eventUtc = Date.UTC(
    CENTURION_EVENT_DATE.year,
    CENTURION_EVENT_DATE.monthIndex,
    CENTURION_EVENT_DATE.day
  );

  return Math.max(0, Math.ceil((eventUtc - todayUtc) / (1000 * 60 * 60 * 24)));
};

const getFormattedUlaanbaatarToday = (language) => {
  return new Intl.DateTimeFormat(language ? "en-US" : "mn-MN", {
    timeZone: "Asia/Ulaanbaatar",
    year: "numeric",
    month: "long",
    day: "numeric"
  }).format(new Date());
};

const CenturionSection = ({ centurion, language, children }) => {
  if (!centurion) {
    return null;
  }

  const importantDates = (centurion.importantDates?.items || []).filter(
    (item) => !HIDDEN_CENTURION_DATE_LABELS.includes(item.label)
  );
  const earlyBirdDates = importantDates.filter(isCenturionEarlyBirdDate);
  const regularDates = importantDates.filter((item) => !isCenturionEarlyBirdDate(item));
  const earlyBirdLabel = earlyBirdDates.length
    ? getCenturionDateLabelParts(earlyBirdDates[0].label).tag
    : CENTURION_EARLY_BIRD_LABEL;
  const today = getFormattedUlaanbaatarToday(language);
  const daysUntil = getDaysUntilCenturionEvent();

  return (
    <section className="centurion">
      <div className="centurion-inner">
        <div className="centurion-left">
          <div className="centurion-title">
            <span className="text">{centurion.title}</span>
          </div>

          <div className="centurion-letter">
            <div className="letter-salutation">{centurion.letter.salutation}</div>
            {centurion.letter.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
            <div className="letter-closing">{centurion.letter.closing}</div>

            <div className="centurion-doctors">
              {centurion.doctors.map((doctor, index) => (
                <div className="doctor-card" key={index}>
                  <img src={doctor.image} alt={doctor.name} />
                  <div className="doctor-info">
                    <div className="doctor-title">{doctor.title}</div>
                    <div className="doctor-name">{doctor.name}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {children}
        </div>

        <aside className="centurion-right">
          <div className="centurion-calendar">
            <div className="today-label">{centurion.calendar.todayLabel}</div>
            <div className="today-date">{today}</div>
            <div className="calendar-image-wrap">
              <img src="/images/centurion-calendar.svg" alt={centurion.calendar.imageAlt} />
              <div className="event-date">{centurion.calendar.eventDateLabel}</div>
            </div>
            <div className="dday">
              <span>{centurion.calendar.ddayPrefix}{daysUntil}</span>
              <small>{centurion.calendar.ddayLabel}</small>
            </div>
          </div>

          <div className="centurion-info-panel">
            <h3>{centurion.importantDates.title}</h3>
            <div className="important-date-list">
              {/* Илтгэлийн хураангуй хүлээн авах item is temporarily hidden. */}
              {earlyBirdDates.length ? (
                <div className="early-bird-date-group">
                  <div className="early-bird-date-heading">
                    <span>{earlyBirdLabel}</span>
                  </div>
                  <div className="early-bird-date-list">
                    {earlyBirdDates.map((item) => {
                      const dateLabel = getCenturionDateLabelParts(item.label).label;

                      return (
                        <div className="important-date early-bird-date" key={item.label}>
                          <span>{dateLabel}</span>
                          <strong>{item.value}</strong>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : null}
              {regularDates.map((item) => (
                <div className="important-date" key={item.label}>
                  <span>{item.label}</span>
                  <strong>{item.value}</strong>
                </div>
              ))}
            </div>
            <ul>
              {centurion.importantDates.notes.map((note, index) => (
                <li key={index}>{note}</li>
              ))}
            </ul>
          </div>

          {/* <div className="centurion-info-panel secretary-office">
            <h3>{centurion.secretaryOffice.title}</h3>
            {centurion.secretaryOffice.contacts.map((contact, index) => (
              <div className="secretary-contact" key={index}>
                <span>{contact.label}</span>
                <strong>{contact.value}</strong>
              </div>
            ))}
          </div> */}
        </aside>
      </div>
    </section>
  );
};

export default CenturionSection;
